export enum FooterBackgroundShade {
  Shade1 = 1,
  Shade2,
  Shade3,
  Shade4,
  Shade5,
}
